module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['loading-container', _vm.showLoading && _vm.needMask && 'loading-need-mask'],
    style: _vm.maskStyle,
    on: {
      "click": _vm.maskClicked
    }
  }, [(_vm.showLoading) ? _c('div', {
    staticClass: ["dof-loading"],
    style: {
      top: _vm.topPosition + 'px'
    }
  }, [_c('div', {
    class: ['loading-box', _vm.loading.class, _vm.loadingText && _vm.loadingText.length > 5 && 'loadingMoreTextBox', _vm.loadingText && _vm.loadingText.length <= 5 && 'loadingTextBox'],
    attrs: {
      "ariaHidden": true
    }
  }, [_c('image', {
    staticClass: ["loading-image"],
    attrs: {
      "src": _vm.loading.url,
      "resize": "contain",
      "quality": "original"
    }
  }), (_vm.loadingText) ? _c('text', {
    class: ['loading-text', _vm.loading.class == 'white-loading' ? 'blackText' : '']
  }, [_vm._v(_vm._s((_vm.loadingText.length <= 15) ? _vm.loadingText : _vm.loadingText.substr(0, 15)))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-4a53a9ce!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-loading/index.vue
// module id = 608
// module chunks = 0 1